import React from 'react'
import { ServicesList } from './list/page'

export const ServicesPage: React.FC = () => {
  return <ServicesList />
}
